module.exports = __webpack_public_path__ + "media/entities/2212-7a620bf1.png";